var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('div',{class:["radio-page"]},[_c('base-container',[_c('radio-example'),_c('radio-disabled'),_c('radio-ui-right')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }